import React, { useState, useEffect, useRef } from 'react';
import io from 'socket.io-client';
import { Layout, Input, Button, List, Avatar, Card,PageHeader,Tag,Result,Spin,Badge } from 'antd';
import { UserOutlined, SendOutlined,CheckCircleOutlined,CloseCircleOutlined,FieldTimeOutlined,InfoCircleOutlined } from '@ant-design/icons';
import { PD_ICON,PD_SOCKET_URI,syncMessage,getMessages } from "./../../services";



const { Header, Content, Footer } = Layout;
const { TextArea } = Input;

// const socket = io(PD_SOCKET_URI);

const ReportChat = (props) => {

  const [userId, setUserId] = useState(props.user_id);
  const [room, setRoom] = useState(`support_${props.user_id}`);
  const [message, setMessage] = useState('');
  const [messages, setMessages] = useState([]);
  const [joined, setJoined] = useState(false);
  const [loading, setLoading] = useState(false);
  const [avatar, setAvatar] = useState('https://via.placeholder.com/40'); // Example avatar
  const [typing, setTyping] = useState(false);
  const [isTyping, setIsTyping] = useState(false);

  const messagesEndRef = useRef(null);
  const chatWindowRef = useRef(null);
  const chatList = document.querySelector('.chatsd > ul'); // Improved selector with descendant combinator


  const loadMessages =async() =>{
    setLoading(true);

    const responseData = await getMessages(props.user_id);

    const {status,data} = responseData;

    if(status==="success"){
        setMessages(data);
        if(data.length){
         scrollToBottom();
        }
    }

    console.log(data);
    joinRoom();

    setLoading(false);
  }


  useEffect(() => {
  loadMessages();

    // socket.on('receiveMessage', (message) => {

    //   console.log(message);

    //   setMessages((prevMessages) => [...prevMessages, message]);
    //   scrollToBottom();
    // });

    // socket.on('userTyping', (data) => {
    //   if (data.user_id !== userId) {
    //     setIsTyping(data.typing);
    //   }
    // });

    

    // return () => {
    //   socket.off('receiveMessage');
    //   socket.off('userTyping');
    // };
  }, [userId]);

  const joinRoom = () => {
  
      // socket.emit('join', { userId, room });
      // setJoined(true);
   
  };



    const sendMessage = async () => {
    // if (message) {
    //   const time = new Date().getTime();

    //   const newMessage = { user_id:userId, room, message, time };

      

    //   socket.emit('sendMessage', newMessage);

    //   await syncMessage(newMessage);
      
    //   // setMessages((prevMessages) => [...prevMessages, newMessage]); // Add only once
    //   setMessage('');
    //   setTyping(false);
    //   socket.emit('typing', { user_id:userId, room, typing: false });
    // }
  };


  const handleTyping = (e) => {
    // setMessage(e.target.value);
    // if (!typing) {
    //   setTyping(true);
    //   socket.emit('typing', { user_id:userId, room, typing: true });
    // }
    // if (e.target.value === '') {
    //   setTyping(false);
    //   socket.emit('typing', { user_id:userId, room, typing: false });
    // }
  };

  // const scrollToBottom = () => {
  //   messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  // };

  const scrollToBottom = () => {
    const chatList = document.querySelector('.pdchat');
    if(chatList){
    chatList.scrollTop = chatList.scrollHeight;
    }

  };

  return (
     <Spin tip="Loading..."  spinning={loading}>
    <Layout >
          
          <div className="site-page-header-ghost-wrapper">
    <PageHeader
      ghost={true}
      style={{boxShadow:"0 0 1em #ccc"}}
      
      title={`Chat between You and  Admin Support`}
      // subTitle= {
      //  props.status === "active" ? (
      //           <Tag icon={<CheckCircleOutlined />} color="green">
      //             Active
      //           </Tag>
      //         ) : props.status === "canceled" ? (
      //           <Tag icon={<CloseCircleOutlined />} color="red">
                
      //             <b>{props.status}</b>
      //           </Tag>
      //         ) : props.status === "expired" ? (
      //           <Tag icon={<CloseCircleOutlined />} color="#ccc">
      //             Expired
      //           </Tag>
      //         ) :  props.status === "grace_period" ? (
      //           <Tag icon={<FieldTimeOutlined  style={{fontSize:"18px"}} />} color="default">
      //                 <Badge status="processing" color="red" text="" />   Grace Period
      //           </Tag>
      //         ) : ( 
      //           <Tag icon={<InfoCircleOutlined />} color="processing">
      //             {props.status}
      //           </Tag>
      //         )
      // }
    
    >
      {/* <Descriptions size="small" column={2}>
        <Descriptions.Item label="Membership">{props.title}</Descriptions.Item>
        <Descriptions.Item label="Date">
          <a>421421</a>
        </Descriptions.Item>
        <Descriptions.Item label="Creation Time">2017-01-10</Descriptions.Item>
        <Descriptions.Item label="Effective Time">2017-10-10</Descriptions.Item>
        <Descriptions.Item label="Remarks">
          Gonghu Road, Xihu District, Hangzhou, Zhejiang, China
        </Descriptions.Item>
      </Descriptions> */}
    </PageHeader>
  </div>
      <Content style={{ padding: '0px 50px' }}>
      <div ref={messagesEndRef}>
          


{messages.length ? 
       <List

              
       size="small"
       itemLayout="horizontal"
       dataSource={messages}
       className='pdchat'
       
       renderItem={(item) => (
         <List.Item
           className={item.user_id === userId ? "me" : "you"}
           style={{ justifyContent: item.userId === userId ? 'flex-end' : 'flex-start' }}
         >
           <List.Item.Meta
             avatar={<Avatar icon={<UserOutlined />} style={{ background: "#000" }} src={PD_ICON} />}
             title={<>{item.user_id === userId ? "You" : "Admin"  }</>}
             description={item.message}
             style={{ textAlign: 'left' }}
           />
         </List.Item>
       )}
       style={{ marginBottom: '20px', height: '60vh', overflowY: 'auto' }}
     /> :  <Result
      status="404"
      title="Chat Support Help"
      subTitle="How can we help you?"
     
    /> }
    
           
          
          </div>
          
      </Content>
      {isTyping && <div className='is_typing' style={{ textAlign: 'left', padding: '0 16px' }}>Admin is typing...</div>}
            <Card>
              <div style={{ display: 'flex', marginTop: '10px' }}>
                <Input
                  value={message}
                  onChange={handleTyping}
                  onPressEnter={sendMessage}
                  placeholder="Type your message..."
                  style={{ flex: 1, marginRight: '10px' }}
                />
                <Button type="primary" icon={<SendOutlined />} onClick={sendMessage}>
                  Send
                </Button>
              </div>
            </Card>
    </Layout> </Spin>
  );
};

export default ReportChat;
